require("./bulkShipments.less");



// WEBPACK FOOTER //
// ./src/pages/bulkShipments/index.js